export default __webpack_public_path__ + "static/media/sendMail.ca7125d7.svg";